import React from 'react'

export default function DashExperience() {
  return (
    <div className='bg-white h-full text-black'>
        <h1>Experience Tab</h1>
    </div>
  )
}
